module.exports = __webpack_public_path__ + "static/media/person3.9eefb186.png";